var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 px-4 my-4 bg-orange-100 text-orange-600 rounded-lg flex"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }